const QUERY_KEY = {
  MEMES: ['memes'],
}

export default QUERY_KEY;